module.exports = require("path");